import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import DefaultPaginationProps from "../../propInterfaces/defaultPaginationProps";
import { getAdminQrsByAdminId } from "../../services/AdminQrApi";
import { AdminQrDTO } from "../../shared/dtos/adminQrDTO";

export const initialState = {
  value: { adminQrDtos: new Array<AdminQrDTO>(), total: 0, take: 10 },
  loading: false,
};

export const adminQrsAsync = createAsyncThunk(
  "adminQrs/",
  async ({ page, take, search: searchText }: DefaultPaginationProps) => {
    const response = await getAdminQrsByAdminId({
      page,
      take,
      search: searchText,
    });
    const adminQrsObject = {
      adminQrDtos: response.data,
      total: response.total,
      take: take,
    };
    return adminQrsObject;
  },
);

export const adminQrsSlice = createSlice({
  name: "adminQrs",
  initialState,
  reducers: {
    updateAdminQrsValue: (state) => {
      state.value.adminQrDtos = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(adminQrsAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(adminQrsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.value.adminQrDtos = state.value.adminQrDtos.concat(
          action.payload.adminQrDtos,
        );
        state.value.total = action.payload.total;
      })
      .addCase(adminQrsAsync.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { updateAdminQrsValue } = adminQrsSlice.actions;

export default adminQrsSlice.reducer;
